import ProjectPage from "../../components/ProjectPage";

// To add a real screenshot: drop the file into src/assets/, import it here
// (e.g. `import shot from "../../assets/nirilium-store.png";`), then add
// `src: shot` to the matching frame below.
export default function Nirilium() {
  return (
    <ProjectPage
      title="Nirilium"
      category="E-commerce"
      tagline="An e-commerce shop, currently in the making."
      body={[
        "Nirilium is an online shop under active development — storefront, product catalog, and checkout are being built out. More to show here soon.",
      ]}
      art="linear-gradient(210deg, rgba(var(--accent-rgb), 0.22) 0%, rgba(var(--text-rgb), 0.03) 70%)"
      // tech + features are draft copy — edit freely
      tech={["React", "Node.js", "Stripe (planned)", "PostgreSQL (planned)"]}
      features={[
        {
          title: "Storefront & product catalog",
          desc: "Browsable catalog with product detail pages.",
        },
        {
          title: "Cart & checkout flow",
          desc: "In progress — cart state and payment integration are being built.",
        },
        {
          title: "Admin product management",
          desc: "Planned — add, edit, and organize products from a dashboard.",
        },
      ]}
      wip
      githubNote="Repository not public yet"
      frames={[
        { type: "web", label: "Storefront — coming soon" },
        { type: "mobile", label: "Mobile — coming soon" },
      ]}
    />
  );
}
